import './Card.scss'

export default {
	name: "eiis-card",
  props: {
    header: String, icon: String, footer: String, href: String,
  },
  methods: {
		link: function () {
			if (this.href)
				document.location.href = this.href;
			return;
		}
  },
  template: `
		<div class="eiis-card" 
				v-bind:class="{'eiis-card-pointer' : href}" 
				v-on:click="link">
			<div class="eiis-card-header" v-if=header>
				{{header}}
      </div>
			
			<div class="eiis-card-content">
			 	<slot></slot>	
			</div>

      <div class="eiis-card-footer" v-if=footer>
				{{footer}}
      </div>
		</div>
  `
}
